import { render } from "./Close.vue?vue&type=template&id=e71f2874"
import script from "./Close.vue?vue&type=script&lang=js"
export * from "./Close.vue?vue&type=script&lang=js"

import "./Close.vue?vue&type=style&index=0&id=e71f2874&lang=scss"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__